<template>
  <div id="app" style="padding:20px;">
    <!-- 登录 -->
    <el-card>
      <h3>登录</h3>
      <el-button type="primary" @click="login">登录</el-button>
      <div v-if="satoken">
        <el-alert title="登录成功" type="success" :closable="false" />
        <p>satoken={{ satoken }}</p>
      </div>
    </el-card>

    <!-- Excel 模板 + 导入 + 一键执行 -->
    <el-card style="margin-top:20px;">
      <h3>Excel 模板</h3>
      <el-button type="success" @click="downloadTemplate">下载模板</el-button>
      <el-upload
        class="upload-demo"
        drag
        action=""
        :http-request="importExcel"
        accept=".xlsx,.xls"
        style="margin-left:20px;display:inline-block;"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">拖拽或<em>点击上传</em></div>
      </el-upload>
      <el-button
        type="danger"
        style="margin-left:20px;"
        :disabled="!tableData.length || !satoken || !appList.length || !attributionList.length"
        @click="executeAll"
      >
        一键执行
      </el-button>
    </el-card>

    <!-- 表格 -->
    <el-card style="margin-top:20px;">
      <h3>数据表格</h3>
      <el-table :data="tableData" border>
        <el-table-column prop="产品名" label="产品名"></el-table-column>
        <el-table-column prop="版位" label="版位"></el-table-column>
        <el-table-column prop="推广目标" label="推广目标"></el-table-column>
        <el-table-column prop="素材类型" label="素材类型"></el-table-column>
        <el-table-column prop="广告主id" label="广告主id"></el-table-column>
        <el-table-column prop="预设归因" label="预设归因"></el-table-column>
        <el-table-column prop="转化事件类型" label="转化事件类型"></el-table-column>
        <el-table-column prop="数据源ID" label="数据源ID"></el-table-column>
        <el-table-column label="日志">
          <template slot-scope="scope">
            <el-button size="mini" @click="showLogs(scope.row)">查看日志</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 日志弹窗 -->
    <el-dialog title="执行日志" :visible.sync="logDialogVisible" width="60%">
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in currentLogs"
          :key="index"
          :timestamp="item.step"
        >
          {{ item.result }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
  name: "App",
  data: function () {
    return {
      satoken: "",
      tableData: [],
      logsMap: {},
      logDialogVisible: false,
      currentLogs: [],
      appList: [],
      attributionList: []
    };
  },
  methods: {
    fetchAppList: function () {
      var self = this;
      axios.get("https://control.zjwec.cn/csmf/api/system/data/auth/getApp", {
        params: { satoken: self.satoken }
      }).then(function (res) {
        if (res.data && res.data.success) {
          self.appList = res.data.data || [];
        }
      }).catch(function () {
        self.$message.error("获取应用列表失败");
      });
    },

    fetchAttributionList: function () {
      var self = this;
      axios.get("https://control.zjwec.cn/csmf/api/admin/advertising/proxy/proxyAttributionList", {
        params: { proxyId: 17, satoken: self.satoken }
      }).then(function (res) {
        if (res.data && res.data.success) {
          self.attributionList = res.data.data || [];
        }
      }).catch(function () {
        self.$message.error("获取预设归因列表失败");
      });
    },

    login: function () {
      var self = this;
      axios
        .post("https://control.zjwec.cn/csmf/login", {
          username: "zhiwei",
          password: "zhiweiFJ#0903",
          autoLogin: false,
          type: "account"
        })
        .then(function (res) {
          if (res.data && res.data.satoken) {
            self.satoken = res.data.satoken;
            self.fetchAppList();
            self.fetchAttributionList();
            self.$message.success("登录成功");
          } else {
            self.$message.error("登录失败");
          }
        })
        .catch(function (err) {
          self.$message.error("登录出错: " + err);
        });
    },
    downloadTemplate: function () {
      var ws = XLSX.utils.json_to_sheet([
        {
          产品名: "",
          版位: "",
          推广目标: "",
          素材类型: "",
          广告主id: "",
          预设归因: "",
          转化事件类型: "",
          数据源ID: ""
        }
      ]);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "模板");
      XLSX.writeFile(wb, "模板.xlsx");
    },
    importExcel: function (param) {
      var self = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });
        var sheetName = workbook.SheetNames[0];
        var sheet = workbook.Sheets[sheetName];
        self.tableData = XLSX.utils.sheet_to_json(sheet);
      };
      reader.readAsArrayBuffer(param.file);
    },
    showLogs: function (row) {
      this.currentLogs = this.logsMap[row["广告主id"]] || [];
      this.logDialogVisible = true;
    },
    async execute(row) {
      const self = this;
      const logs = [];
      self.logsMap[row["广告主id"]] = logs;

      function log(step, result) {
        logs.push({ step, result });
      }

      try {
        const app = self.appList.find(a => a.appName === row["产品名"]);
        const attr = self.attributionList.find(a => a.title === row["预设归因"]);

        if (!app || !attr) {
          log("校验", "app 或归因未匹配");
          return;
        }

        const payload = {
          accountId: "20240528045",
          advertiserId: row["广告主id"],
          appId: app.appId,
          proxy: attr.proxyId,
          attributionPresetId: attr.id,
          attributionBehavior: attr.attributionBehavior,
          attributionBehaviorParams: attr.attributionBehaviorParams,
          activationReturnPercent: 100,
          maxLandingPageJumpCount: 10,
          landingPageJumpInterval: 1,
          channel: "vivo",
          media: "vivo",
          mediaChannel: row["版位"] === "主站" ? "main" : "league",
          mediumType: "direct",
          jumpMode: row["推广目标"] === "h5" ? "url" : "hap",
          materialType: self.mapMaterial(row["素材类型"]),
          shieldedCities:
              "北京市,广州市,上海市,深圳市,重庆市,杭州市,南京市,厦门市,西安市,苏州市,绍兴市,杭州市,成都市,合肥市,宁波市,天津市,佛山市,东莞市,青岛市,济南市,长沙市",
          status: 1,
          useGlobalJumpConfig: false,
          autoDailyBudget: 1,
          autoStatus: 0
        };

        // 创建计划
        await axios.post(
            "/csmfapi/api/analysis/proxy/daily/dataReport/proxyPlanCreate",
            payload,
            { headers: { "satoken": self.satoken } }
        );
        log("创建计划", "成功");

        // 获取计划，最多尝试 10 次
        let plan = null;
        for (let attempt = 1; attempt <= 10; attempt++) {
          const res2 = await axios.get(
              "/csmfapi/api/analysis/proxy/daily/dataReport/proxyPlanList?current=1&pageSize=100",
              { headers: { "satoken": self.satoken } }
          );
          const list = res2.data.data || [];
          plan = list.find(p => p.advertiserId === payload.advertiserId);

          if (plan) {
            log("获取计划", `成功 planId=${plan.plan} (第${attempt}次尝试)`);
            break;
          } else {
            log("获取计划", `未找到 (第${attempt}次尝试)`);
            await new Promise(r => setTimeout(r, 1000)); // 每次间隔 1 秒再请求
          }
        }

        if (!plan) {
          log("获取计划", "失败，超过最大尝试次数");
          return;
        }

        // 配置归因
        await axios.post(
            "/csmfapi/api/advertising/attribution/config",
            {
              monitorId: plan.monitorId,
              appId: plan.appId,
              media: "vivo",
              channel: "vivo",
              planId: plan.plan,
              packageName: plan.packageName,
              advertiserId: plan.advertiserId,
              attributionBehavior: plan.attributionBehavior,
              maxLandingPageJumpCount: 10,
              type: "custom",
              convertType:
                  row["转化事件类型"] === "添加到桌面"
                      ? "ADD_SCREEN"
                      : row["转化事件类型"] === "激活"
                          ? "ACTIVATION"
                          : "UNKNOWN",
              srcType: "Quickapp",
              srcId: row["数据源ID"]
            },
            { headers: { "satoken": self.satoken } }
        );
        log("归因配置", "成功");

        // 开启监控
        await axios.get(
            "/csmfapi/api/advertising/activity/monitor/" + plan.monitorId,
            { headers: { "satoken": self.satoken } }
        );
        log("开启监控", "成功");

        // 自定义函数
        await self.checkMonitor(plan.monitorId, log);

      } catch (err) {
        log("错误", err.message || JSON.stringify(err));
      }
    },

    // 串行执行所有行
    async executeAll() {
      const self = this;
      try {
        for (const row of self.tableData) {
          await self.execute(row); // 串行逐个执行
        }
        self.$message.success("所有数据执行完成");
      } catch (err) {
        self.$message.error("执行过程中有错误: " + (err.message || err));
      }
    },
    checkMonitor: function (monitorId, log, done) {
      var self = this;
      var tries = 0;
      function poll() {
        tries++;
        axios
          .get(
            "/csmfapi/api/advertising/activity/monitor/debug?monitorId=" +
            monitorId,
            { headers: { "satoken": self.satoken } }
          )
          .then(function (res) {
            var data = res.data;
            if (data && data.data && data.data.logs && data.data.logs.length >= 4) {
              var msg = data.data.logs[3].message[0];
              if (msg === "调试结果: 成功") {
                log("监控检测", "成功");
                done && done();
                return;
              }
            }
            if (tries < 5) {
              setTimeout(poll, 2000);
            } else {
              log("监控检测", "失败(5次未成功)");
              done && done();
            }
          })
          .catch(function (err) {
            log("监控检测", "错误 " + err);
            done && done();
          });
      }
      poll();
    },
    mapMaterial: function (val) {
      var map = {
        清理页: "isClearPage",
        字体放大: "isFontSize",
        天气页: "isWeatherPage",
        省电页: "isElectric",
        养生: "isYangshen",
        wifi页: "isWifi",
        计步: "isStepNumber",
        红包: "isRedPacketPage",
        壁纸: "isBizhi",
        领红包: "isReward",
        短剧: "isVideo"
      };
      return map[val] || "isDefault";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/kehu/csmfqd.vue